// @ts-ignore
import * as yup from 'yup';
// @ts-ignore
import {nl} from "yup-locales";

// Define your custom messages
const customMessages = {
    mixed: {
        required: 'Dit veld is verplicht',
    },
};

const mergedLocale = {
    ...nl,
    mixed: { ...nl.mixed, ...customMessages.mixed },
};

yup.setLocale(mergedLocale);

export default yup;

